import React from "react";
import {
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Flex,
  Textarea,
  Switch,
} from "@chakra-ui/react";
import { Field } from "formik";
import Select from "react-select";
import moment from "moment";

const CustomField = ({
  name,
  placeholder = "",
  title,
  type = "text",
  inputType = "input",
  options = [],
  hLabel = false,
  multiSelect = false,
  isClearable = true,
  customStyle = { color: "menu.700" },
  customFontColor,
  props,
  onChangeFunc = () => {},
  setIsEdited = () => {},
}) => {
  const findMultipleOptions = (options, values) => {
    let founded = [];
    options.forEach((opt) => {
      let valueFounded = values.find((val) => val.label === opt.label);
      if (valueFounded) founded = [...founded, opt];
    });
    return founded;
  };
  moment.locale();

  const handleEdit = () => {
    setIsEdited(true);
  };

  const typeSelector = (field, form) => {
    switch (inputType) {
      case "input":
        return (
          <Input
            onWheel={(e) => e.target.blur()}
            type={type}
            {...field}
            value={
              type === "date"
                ? moment(field.value).format("YYYY-MM-DD")
                : field.value
            }
            id={`${name}`}
            placeholder={placeholder}
            onChange={(val) => {
              handleEdit();
              props.setFieldValue(`${name}`, val.target.value);
              onChangeFunc(val.target.value);
            }}
            fontSize={"0.9rem"}
          />
        );
      case "textArea":
        return (
          <Textarea
            {...field}
            rows={3}
            onChange={(val) => {
              handleEdit();
              props.setFieldValue(`${name}`, val.target.value);
              onChangeFunc(val.target.value);
            }}
            type={type}
            id={`${name}`}
            placeholder={placeholder}
            fontSize={"0.9rem"}
          />
        );
      case "select":
        return (
          <Select
            id={`${name}`}
            placeholder={placeholder}
            isMulti={multiSelect}
            options={options}
            isClearable={isClearable}
            value={
              multiSelect
                ? field.value && findMultipleOptions(options, field.value)
                : field.value &&
                  options.find((item) => item.label === field.value.label)
            }
            onChange={(val) => {
              handleEdit();
              if (multiSelect) {
                let newValArray = [];
                val.forEach((item) => {
                  newValArray = [...newValArray, item];
                });
                props.setFieldValue(`${name}`, newValArray);
              } else {
                val === null
                  ? props.setFieldValue(`${name}`, null)
                  : props.setFieldValue(`${name}`, val);
              }
              onChangeFunc(val.value);
            }}
            styles={{
              control: (provided) => ({
                ...provided,
                borderColor:
                  form.errors[`${name}`] && form.touched[`${name}`]
                    ? "#E53E3E"
                    : "inherit",
                boxShadow:
                  form.errors[`${name}`] && form.touched[`${name}`]
                    ? "0 0 0 1px #e53e3e"
                    : "inherit",
              }),
              valueContainer: (provided, state) => ({
                ...provided,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                fontSize: "0.9rem",
              }),
            }}
          />
        );

      case "switch":
        return (
          <Switch
            id={`${name}`}
            isChecked={field.value}
            onChange={(value) => {
              handleEdit();
              props.setFieldValue(`${name}`, value.target.checked);
            }}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Field name={`${name}`}>
        {({ field, form }) => (
          <FormControl
            isInvalid={form.errors[`${name}`] && form.touched[`${name}`]}
          >
            <Flex
              direction={hLabel ? "row" : "column"}
              w="100%"
              display="flex"
              h={hLabel ? "100%" : "auto"}
              alignItems={hLabel ? "center" : "auto"}
            >
              <FormLabel
                htmlFor={`${name}`}
                mb="0"
                style={customStyle}
                color={customFontColor}
                fontSize={"0.9rem"}
              >
                {title}
              </FormLabel>
              {typeSelector(field, form)}
            </Flex>
            <FormErrorMessage>{form.errors[`${name}`]}</FormErrorMessage>
          </FormControl>
        )}
      </Field>
    </>
  );
};

export default CustomField;
